import {Button, Form, InputNumber, Modal, notification, Typography} from 'antd';
import merchantSettlementService from "../../../../services/ewallet_integration/merchant_settlement.service";


const MerchantSettlementModal = (props) => {
    const { visible, onClose , initialData = null, merchant, setRefresh } = props;
    const [form] = Form.useForm();

    const handleFinish = async (values) => {
        try {
            // Add country to values
            const payload = {
                ...values,
                country: 164,
            };
            await merchantSettlementService.createMerchantSettlement(merchant.merchant_id, payload);
            notification.success({
                message: 'Settlement Created',
                description: `Settled successfully.`,
            });

            setRefresh(true);
            onClose();
        } catch (err) {
            notification.error({
                message: 'Settlement Failed',
                description: err?.response?.data?.message || 'Something went wrong while creating settlement.',
            });
        }

        form.resetFields();
    };


    return (
        <Modal
            title={initialData ? 'Edit Settlement' : 'Create Settlement'}
            open={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                <Form.Item
                    label="Melon"
                    name="amount"
                    rules={[{ required: true, message: 'Please enter Melon' }]}
                >
                    <InputNumber
                        min={0}
                        max={
                            merchant && merchant.wallet?.melon_balance > 0
                            ? parseFloat(merchant.wallet.melon_balance)
                            : undefined
                    }
                        step={0.01}
                        precision={2}
                        style={{ width: '100%' }}
                    />

                </Form.Item>

                <Form.Item
                    label="Payment Amount"
                    name="payment_amount"
                    rules={[{ required: true, message: 'Please enter Payment Amount' }]}
                >
                    <InputNumber
                        min={0}
                        step={0.01}
                        precision={2}
                        style={{ width: '100%' }}
                    />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                        Settle
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default MerchantSettlementModal;
